import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { useTranslation } from '../../application/hooks/useTranslation';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="state-box" data-testid="not-found">
      <h1 style={{ fontSize: 'var(--font-size-lg)' }}>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <Link to="/">
        <Button variant="secondary">{t('held.back')}</Button>
      </Link>
    </div>
  );
}
